const MAX_ATTEMPTS = 5;
const LOCK_DURATION = 3 * 60 * 1000;

const normalizeUsername = (username = '') => username.trim().toLowerCase();

export const getStorageKey = (username, market) =>
  `login_attempts_${market}_${normalizeUsername(username)}`;

// const getLockedUserKey = (market) =>
//   `locked_login_user_${market}`;

// export const getLockedUsername = (market) => {
//   return localStorage.getItem(getLockedUserKey(market));
// };

// export const clearLockedUsername = (market) => {
//   localStorage.removeItem(getLockedUserKey(market));
// };

export const isLocked = (username, market) => {
  if (!username) return false;

  username = normalizeUsername(username);

  const key = getStorageKey(username, market);

  const data = JSON.parse(localStorage.getItem(key)) || {};

  if (data.lockUntil && Date.now() < data.lockUntil) {
    return true;
  }

  if (data.lockUntil && Date.now() >= data.lockUntil) {
    localStorage.removeItem(key);
  }

  return false;
};

export const recordFailedAttempt = (username, market) => {
  username = normalizeUsername(username);

  const key = getStorageKey(username, market);

  let data = JSON.parse(localStorage.getItem(key)) || {
    username,
    count: 0,
    firstAttempt: Date.now()
  };

  const now = Date.now();

  if (now - data.firstAttempt > LOCK_DURATION) {
    data = {
      username,
      count: 0,
      firstAttempt: now
    };
  }

  data.count++;

  if (data.count >= MAX_ATTEMPTS) {
    data.lockUntil = now + LOCK_DURATION;
  }

  localStorage.setItem(key, JSON.stringify(data));
};

export const resetAttempts = (username, market) => {
  username = normalizeUsername(username);

  const key = getStorageKey(username, market);

  localStorage.removeItem(key);
};
